// Shared mapping of the raw enrichmentStatus enum (a backend phase: none | pending |
// extracting | parsing | embedding | complete | failed) to user-facing label + badge color.
// Used by the candidate profile sidebar and the Re-enrich buttons so the raw enum never
// leaks into the UI. Keep these in sync with the enrich_status_* keys in i18n.js.

const STATUS_COLORS = {
  none: "gray",
  pending: "blue",
  extracting: "blue",
  parsing: "blue",
  embedding: "blue",
  complete: "green",
  failed: "red",
};

/** True while enrichment is queued or actively running (i.e. not idle/done/failed). */
export function isEnrichmentInProgress(status) {
  return !!status && status !== "none" && status !== "complete" && status !== "failed";
}

/** Friendly, localized label for a raw enrichmentStatus enum. `t` is the Veft-namespace t(). */
export function enrichmentStatusLabel(status, t) {
  const key = status || "none";
  return t(`enrich_status_${key}`, { defaultValue: key });
}

/** Mantine color for the status badge. */
export function enrichmentStatusColor(status) {
  return STATUS_COLORS[status] ?? "gray";
}

/**
 * Localized price string for a credit amount, given the tenant rate card from
 * getEnrichmentCostBasis(). Defaults to EUR for the German UI, USD otherwise.
 * Returns null when the rate card hasn't loaded yet.
 */
export function creditPrice(costBasis, credits, language) {
  if (!costBasis) return null;
  const isEur = (language || "").toLowerCase().startsWith("de");
  const per1000 = isEur ? costBasis.eurPer1000Credits : costBasis.usdPer1000Credits;
  const sym = isEur ? "€" : "$";
  return `${sym}${((credits / 1000) * per1000).toFixed(2)}`;
}
